exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 > a {\n  color: #129286;\n  text-decoration: none;\n}\n\n.MoviesContainer {\n  position: relative;\n}", ""]);

// exports
